// https://vuex.vuejs.org/en/mutations.html

export default {
  //
};
